export default "__VITE_ASSET__BeXSBKBt__"